import {
  getOrdersSettings as publicGetOrdersSettings,
  updateOrdersSettings as publicUpdateOrdersSettings,
} from './ecom-v1-orders-settings-orders-settings.public.js';
import { createRESTModule } from '@wix/sdk-runtime/rest-modules';
import { createEventModule } from '@wix/sdk-runtime/event-definition-modules';
import {
  BuildRESTFunction,
  MaybeContext,
  BuildEventDefinition,
} from '@wix/sdk-types';
import { onOrdersSettingsUpdated as publicOnOrdersSettingsUpdated } from './ecom-v1-orders-settings-orders-settings.public.js';

export const getOrdersSettings: MaybeContext<
  BuildRESTFunction<typeof publicGetOrdersSettings> &
    typeof publicGetOrdersSettings
> = /*#__PURE__*/ createRESTModule(publicGetOrdersSettings);
export const updateOrdersSettings: MaybeContext<
  BuildRESTFunction<typeof publicUpdateOrdersSettings> &
    typeof publicUpdateOrdersSettings
> = /*#__PURE__*/ createRESTModule(publicUpdateOrdersSettings);
/**
 * Triggered when orders settings are updated.
 */
export const onOrdersSettingsUpdated: BuildEventDefinition<
  typeof publicOnOrdersSettingsUpdated
> &
  typeof publicOnOrdersSettingsUpdated = createEventModule(
  publicOnOrdersSettingsUpdated
);

export {
  InventoryUpdateTrigger,
  WebhookIdentityType,
} from './ecom-v1-orders-settings-orders-settings.universal.js';
export {
  OrdersSettings,
  GetOrdersSettingsRequest,
  GetOrdersSettingsResponse,
  UpdateOrdersSettingsRequest,
  UpdateOrdersSettingsResponse,
  DeleteOrdersSettingsRequest,
  DeleteOrdersSettingsResponse,
  ListOrdersSettingsRequest,
  ListOrdersSettingsResponse,
  DomainEvent,
  DomainEventBodyOneOf,
  EntityCreatedEvent,
  RestoreInfo,
  EntityUpdatedEvent,
  EntityDeletedEvent,
  ActionEvent,
  MessageEnvelope,
  IdentificationData,
  IdentificationDataIdOneOf,
  AccountInfo,
  BaseEventMetadata,
  EventMetadata,
  AccountInfoMetadata,
  OrdersSettingsUpdatedEnvelope,
} from './ecom-v1-orders-settings-orders-settings.universal.js';
export {
  InventoryUpdateTriggerWithLiterals,
  WebhookIdentityTypeWithLiterals,
} from './ecom-v1-orders-settings-orders-settings.universal.js';
